<template>
    <div :class="'product-prices ' + className">
        <p
            v-if="priceData && priceData.discount"
            class="headline text--darken-4 ma-0 product-old-price">
            <del>{{priceData.original_price_inkl_vat | currency}}</del>
        </p>
        {{price | currency}}
    </div>

</template>

<script>

const name = 'ProductPrice';

export default {
    name: name,
    props: {
        price: {},
        priceData: {},
        className: {
            default: 'display-1',
        },
    },
    methods: {
        onShowFeesInfo(merchant) {
            this.currentMerchant = merchant;
            this.showFeesModal = true;
        },
    },
    watch: {
        showFeesModal(value) {
            if (!value) {
                this.currentMerchant = null;
                this.showFeesModal = false;
            }
        },
    },
};
</script>

<style>
.product-prices {
    display: inline-block;
}
.product-old-price {
    color: #919191;
}
</style>